import {
  Grid, IconButton, InputAdornment, Stack, Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Link } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import palette from '../../../theme/palette';
import { formikForm } from '../../../hoc';
import { MutedText } from '../../../components/CustomTypography';
import TextFieldWithError from '../../../components/FormComponents/TextfieldWithError';

function RegisterForm(props) {
  const {
    formik, auth, handleBackToLogin, showPassword, setShowPassword,
  } = props;
  const {
    handleChange, touched, errors, getIn,
  } = formik;

  return (
    <Grid container>
      <Stack>
        <Typography variant="h4">Register</Typography>
        <MutedText text="Please provide your details" />
      </Stack>

      <Grid item xs={12}>
        <TextFieldWithError
          name="orgName"
          onChange={handleChange}
          label="Organization"
          error={touched.orgName && getIn(errors, 'orgName')}
        />

        <TextFieldWithError
          name="name"
          onChange={handleChange}
          label="Name"
          type="text"
          error={touched.name && getIn(errors, 'name')}
        />

        <TextFieldWithError
          name="email"
          onChange={handleChange}
          label="Email"
          type="email"
          error={touched.email && getIn(errors, 'email')}
        />

        <TextFieldWithError
          name="password"
          type={showPassword ? 'text' : 'password'}
          onChange={handleChange}
          label="Password"
          error={touched.password && getIn(errors, 'password')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton style={{ color: 'grey' }} onClick={setShowPassword} edge="end">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {/* Action Buttons */}
      <Grid item xs={12}>
        <LoadingButton
          color="primary"
          loading={auth?.loading || false}
          variant="contained"
          fullWidth
          sx={{ mb: '10px' }}
          type="submit"
        >
          Submit
        </LoadingButton>
      </Grid>

      <Grid item xs={12} style={{ textAlign: 'right' }}>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          Already have an account ?
          {' '}
          <Link onClick={handleBackToLogin} to="/login" variant="body2" style={{ textDecoration: 'none', color: palette.primary.mainColor }}>
            Login
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default formikForm(RegisterForm);
